import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../../graphql/query/ListItems";
import { SelectList } from "../../../../../components/Functional";
import { useNavigate } from "react-router-dom";

const Actions = props => {
  const { listId, workingListId } = props || {};
  const navigate = useNavigate();

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.RemoveSelected {...props} />
      <SelectList.ClearList {...props} listId={listId || workingListId} />
      {listId ? (
        <SelectList.ExitEditMode
          onSuccess={() => (
            props?.onSuccess?.(), navigate("/invoice?status=selectListSaved")
          )}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: 9,
            onSuccess: () => (
              props?.onSuccess?.(), navigate("/invoice?status=selectListSaved")
            ),
          }}
        />
      )}
    </div>
  );
};

const tableProps = props => {
  const { listId, workingListId } = props || {};
  // Prioritize listId (saved list) over workingListId (working list)
  const finalListId = listId || workingListId;

  const tableProps = {
    dataKey: "listItems",
    fetchPolicy: "network-only",
    FETCH_QUERY: fetchListItems({
      item: {},
    }),
    skip: () => !finalListId,
    variables: {
      listId: finalListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
